import { render, staticRenderFns } from "./form5_1b.vue?vue&type=template&id=4badfa0b&scoped=true&"
import script from "./form5_1b.vue?vue&type=script&lang=js&"
export * from "./form5_1b.vue?vue&type=script&lang=js&"
import style0 from "./form5_1b.vue?vue&type=style&index=0&id=4badfa0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4badfa0b",
  null
  
)

export default component.exports